module.exports = __webpack_public_path__ + "static/media/mobile.422842a1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/mobile.webp
// module id = 290
// module chunks = 0